<template>
    <b-container fluid class="mt--7">
        <b-card
            title="Customer User Email Parts"
            sub-title="Used only when email is not known"
        >
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="fieldset-domain"
                        label="Email Domain"
                        label-for="input-domain"
                    >
                        <b-form-input
                            id="input-domain"
                            v-model="formData.emailDomain"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-suffix"
                        label="Dummy Suffix"
                        label-for="input-suffix"
                    >
                        <b-form-input
                            id="input-suffix"
                            v-model="formData.usernameSuffix"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-button
                        variant="primary"
                        @click="updateSettings"
                        size="sm"
                    >
                        <b-spinner
                            small
                            v-if="updating"
                            label="Loading..."
                        ></b-spinner>
                        <span v-else>Update</span>
                    </b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'emailPartsValue',
    mixins: [popupMixins, permissionsMixins],

    data: () => ({
        componentName:'Email Settings',
        formData: {
            emailDomain: null,
            usernameSuffix: null,
        },
        updating: false,
    }),

    computed: {
        emailPartsValue() {
            return this.$store.getters['company/emailPartsValue']
        },

        emailPartsKey() {
            return this.$store.state.company.settingKeys.emailPartsKey
        },
    },

    watch: {
        emailPartsValue: {
            handler: function (val) {
                console.log('watch emailPartsValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.emailPartsKey
        )
        this.$nextTick(() => {
            this.updateModel(this.emailPartsValue)
        })
    },

    methods: {
        updateModel(emailPartsValue) {
            console.log('emailPartsValue:', emailPartsValue)
            const value = { ...(emailPartsValue || {}) }
            this.$set(this.formData, 'emailDomain', value.emailDomain)
            this.$set(this.formData, 'usernameSuffix', value.usernameSuffix)
        },
        async updateSettings() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false

                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.emailPartsKey,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName,'Updated','success',`${this.componentName} successfully updated`)
                //this.doToast('Success!', 'Settings Updated', 'success')


            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
